import { GB, GR } from "country-flag-icons/react/3x2";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import sendGDPREmail from "../services/sendGDPREmail";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/slices/ui";
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    style={{ color: "var(--bs-card-color)" }}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const SendEmailGDPR = ({ email }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.trdr);
  const gdprs = useSelector((state) => state.gdpr);

  const handleSendEmail = async (lang) => {
    dispatch(setLoading(true));

    const objFinal = data.gdpr
      .map(({ code, fromDate }) => {
        const ff = new Date(fromDate);
        if (ff.getFullYear() < 2025) {
          return null;
        } else {
          const match = gdprs.find((entry) => entry.code === String(code));
          return match ? { code: lang == "GR" ? match.template : match.templateeng, name: match.name } : null;
        }
      })
      .filter(Boolean);
    if (objFinal.length > 0) {
      await sendGDPREmail({ lang, trdr: data.trdr, templates: objFinal, email: data.email });
    }
    dispatch(setLoading(false));
  };

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        <MdEmail size={50} style={{ opacity: email && email != "" ? 1 : 0.5 }} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="mb-1">
        <Dropdown.Item className="d-flex" onClick={() => handleSendEmail("GR")}>
          <GR title="Greece" width={32} className="me-1" />
          Ελληνικά
        </Dropdown.Item>
        <Dropdown.Item className="d-flex" onClick={() => handleSendEmail("ENG")}>
          <GB title="English" width={32} className="me-1" />
          Αγγλικά
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SendEmailGDPR;
